// src/components/Seo.js (GÜNCELLE) - robots desteği eklendi
import { useEffect } from "react";

function set(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setOg(prop, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  const link = document.getElementById("canonical-link") || (() => {
    const l = document.createElement("link");
    l.id = "canonical-link";
    l.rel = "canonical";
    document.head.appendChild(l);
    return l;
  })();
  link.href = href;
}

function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export default function Seo({
  title,
  description,
  path = "/",
  ogImage,
  ldJson,
  robots // örn: "noindex,nofollow"
}) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) set("description", description);

    const urlBase = "https://www.ornek-domain.com/";
    const url = urlBase + path.replace(/^#?\/?/, "/");

    setCanonical(url);
    setOg("og:title", title);
    setOg("og:description", description);
    setOg("og:url", url);
    if (ogImage) setOg("og:image", ogImage);

    if (ldJson) setJsonLd("ld-dynamic", ldJson);

    set("twitter:title", title);
    set("twitter:description", description);
    if (ogImage) set("twitter:image", ogImage);

    if (robots) set("robots", robots);
  }, [title, description, path, ogImage, ldJson, robots]);

  return null;
}